<template>
  <div class="loading" id="loading_text" :style="{ color: computedTextColor }">{{loading_text}}</div>
  <div class="createdBy" :style="{ color: computedTextColor }">PRESS SPACE TO CHANGE COLOR<br>CREATED BY XUAN TANG<br>CONTACT: TXSTC55@GMAIL.COM</div>
  <div class="canvWrapper">
    <canvas class="canvas" ref="myCanvas" />
  </div>
</template>
<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import colors from "../assets/colors.json"

var shaderAttributes = [{
    planeSpeed: "time / (1.0 + offsets[i]) + offsets[i]",
    angleSpeed: "time * (3.0 + offsets[i]) + offsets[i]",
    angleModifier: ".3",
    lines: 70
  },
  {
    planeSpeed: "time / (1.0 + offsets[i]) + offsets[i]",
    angleSpeed: "time / (2.0 + offsets[i]) + offsets[i]",
    angleModifier: "2.0",
    lines: 25
  },
  {
    planeSpeed: "time / (2.0 + offsets[i]) + offsets[i]",
    angleSpeed: "time * (8.0 + offsets[i]) + offsets[i]",
    angleModifier: "0.5",
    lines: 60
  },
  {
    planeSpeed: "time / (2.0 + offsets[i]) + offsets[i]",
    angleSpeed: "time / (0.1 + offsets[i]) + offsets[i]",
    angleModifier: "2.0",
    lines: 25
  },
  {
    planeSpeed: "time / (0.1 + offsets[i]) + offsets[i]",
    angleSpeed: "time * (0.1 + offsets[i]) + offsets[i]",
    angleModifier: "0.8",
    lines: 45
  },
  {
    planeSpeed: "(time / (0.1 + offsets[i]) + offsets[i]) / 3.0",
    angleSpeed: "time * (1.0 + offsets[i]) + offsets[i]",
    angleModifier: "1.5",
    lines: 30
  },

];


var shaderAttribute = shaderAttributes[Math.floor(Math.random() * shaderAttributes.length)];
// var shaderAttribute = shaderAttributes[5];

var chosen_color = colors[Math.floor(Math.random() * colors.length)];

// var choice1 = Math.random() > 0.5 ? 0 : 3;
var choice2 = Math.random() > 0.5 ? 0 : 1;
var bg_color = chosen_color[0];
var line_color1 = chosen_color[1 + choice2];
var line_color2 = chosen_color[2 - choice2];
var text_color = chosen_color[3];


let scene,
  camera,
  renderer,
  controls,
  loader,
  mixer,
  catObject;

var clock = null;


var myMaterial = new THREE.ShaderMaterial({
  uniforms: {
    color1: { value: new THREE.Color(line_color1) },
    color2: { value: new THREE.Color(line_color2) },
    planes: { value: [] },
    offsets: { value: [] },
    minOffset: { value: -1.0 },
    maxOffset: { value: 1.0 },
    time: { value: 0 },
    center: { value: new THREE.Vector3(0, 0, 0) }

    // bindMatrix: { value: new THREE.Matrix4() },
    // boneMatrices: { value: [] }
  },
  vertexShader: `
    varying vec2 vUv;
    #ifdef USE_SKINNING
      uniform mat4 bindMatrix;
      uniform mat4 bindMatrixInverse;
      uniform highp sampler2D boneTexture;
      uniform int boneTextureSize;

      out vec4 mvPosition;
      out vec3 positionCopy;

      mat4 getBoneMatrix( const in float i ) {
        float j = i * 4.0;
        float x = mod( j, float( boneTextureSize ) );
        float y = floor( j / float( boneTextureSize ) );
        float dx = 1.0 / float( boneTextureSize );
        float dy = 1.0 / float( boneTextureSize );
        y = dy * ( y + 0.5 );
        vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
        vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
        vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
        vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
        mat4 bone = mat4( v1, v2, v3, v4 );
        return bone;
      }
    #endif
    void main() {

      vUv = uv;
      positionCopy = position;
      #ifdef USE_SKINNING
        mat4 boneMatX = getBoneMatrix( skinIndex.x );
        mat4 boneMatY = getBoneMatrix( skinIndex.y );
        mat4 boneMatZ = getBoneMatrix( skinIndex.z );
        mat4 boneMatW = getBoneMatrix( skinIndex.w );
        mat4 skinMatrix = mat4( 0.0 );
        skinMatrix += skinWeight.x * boneMatX;
        skinMatrix += skinWeight.y * boneMatY;
        skinMatrix += skinWeight.z * boneMatZ;
        skinMatrix += skinWeight.w * boneMatW;
        skinMatrix  = bindMatrixInverse * skinMatrix * bindMatrix;
        vec4 skinVertex = bindMatrix * vec4( position, 1.0 );
        vec4 skinned = vec4( 0.0 );
        skinned += boneMatX * skinVertex * skinWeight.x;
        skinned += boneMatY * skinVertex * skinWeight.y;
        skinned += boneMatZ * skinVertex * skinWeight.z;
        skinned += boneMatW * skinVertex * skinWeight.w;
        skinned  = bindMatrixInverse * skinned;
        mvPosition = modelViewMatrix * skinned;
        mvPosition.y -= 4.0;
      #else
        mvPosition = modelViewMatrix * vec4( position, 1.0 );
        mvPosition.y -= 4.0;
      #endif
      gl_Position = projectionMatrix * mvPosition;
    }`,
  fragmentShader: `
    uniform vec3 color1;
    uniform vec3 color2;
    varying vec2 vUv;
    in vec4 mvPosition;
    in vec3 positionCopy;
    uniform vec4 planes[${shaderAttribute.lines}];
    uniform float time;
    uniform float offsets[${shaderAttribute.lines}];
    uniform float minOffset;
    uniform float maxOffset;
    uniform vec3 center;

    float hasIntersection = -1.0;
    float distance = 100.0;
    float offset = 0.0;
    float angle;
    float timedAngle = 0.0;
    float end = 0.0;
    int pickedIndex = 0;

    float ATan2(vec2 dir)
    {
      float angle = asin(dir.x) > 0.0 ? acos(dir.y) : -acos(dir.y);
      return angle;
    }

    float myMod(float a, float b)
    {
      return a - (b * floor(a/b));
    }

    void main() {
      for (int i = 0; i < ${shaderAttribute.lines}; i++){
        offset = sin(${shaderAttribute.planeSpeed});
        offset = offset * (maxOffset - minOffset) / 4.0;
        distance = abs(dot(planes[i].xyz, positionCopy) + planes[i].w + offset);
        if (distance < 0.001){
          // now check if angle is correct
          vec3 direction = positionCopy - center;
          angle = ATan2(normalize(vec2(direction.x, direction.y))) + 3.14150265;
          timedAngle = myMod((${shaderAttribute.angleSpeed}) , 3.14159265 * 2.0);
          angle = angle - timedAngle < 0.0? (angle - timedAngle + 2.0 * 3.14159265) : angle - timedAngle;
          if (angle <= 3.14159265 * ${shaderAttribute.angleModifier}){
            hasIntersection = 1.0;
            pickedIndex = i;
            break;
          }
        }
      }
      if (hasIntersection > 0.0){
        if (positionCopy.x > 0.0){
          gl_FragColor = vec4(color1 + (color2 - color1) * (sin(time * offsets[pickedIndex] + offsets[pickedIndex]) + 1.0) / 2.0, 1.0);
        }else{
          gl_FragColor = vec4(color2 + (color1 - color2) * (sin(time * offsets[pickedIndex] + offsets[pickedIndex]) + 1.0) / 2.0, 1.0);
        }
      } else {
        // gl_FragColor = vec4(color2, 1.0);
        discard;
      }
    }
  `,
  skinning: true,
  side: THREE.DoubleSide,
  transparent: true,
});



export default {
  name: "Cat",
  data() {
    return {
      loadingDone: false,
      loading_text: "0% LOADED, IT MAY TAKE A WHILE",
      planes: [],
      bbox: null,
      action_numbers: [3, 9, 11, 15, 21, 25, 26, 27, 30, 33, 38, 40, 41, 44, 47, 48, 50, 52, 55, 58, 60, 61, 62, 65, 67, 70, 71, 74, 78, 80, 83, 84, 87, 97, 100, 101, 105, 113, 114, 115, 120, 122],
      // action_numbers: [3, 9, 11],
      animation_actions: [],
      animation_weights: [],
      current_action_index: 0,
      oldTime: 0,
      canChooseNew: true,
      computedTextColor: text_color,
    };
  },
  computed: {},
  methods: {

    setWeight(action, weight) {
      action.enabled = true;
      action.setEffectiveTimeScale(1);
      action.setEffectiveWeight(weight);
    },


    activateAction(ind) {
      this.setWeight(this.animation_actions[ind], this.animation_weights[ind]);
      this.animation_actions[ind].play();
    },


    prepareCrossFade(startAction, endAction, duration, newChoice) {

      // If the current action is 'idle', execute the crossfade immediately;
      // else wait until the current action has finished its current loop
      if (!startAction || !endAction) {
        this.executeCrossFade(startAction, endAction, duration, newChoice);
      } else {
        this.synchronizeCrossFade(startAction, endAction, duration, newChoice);
      }
    },

    executeCrossFade(startAction, endAction, duration, newChoice) {
      // Not only the start action, but also the end action must get a weight of 1 before fading
      // (concerning the start action this is already guaranteed in this place)
      if (endAction) {
        this.setWeight(endAction, 1);
        endAction.time = 0;
        if (startAction) {
          // Crossfade with warping
          startAction.crossFadeTo(endAction, duration, true);
        } else {
          // Fade in
          endAction.fadeIn(duration);
        }
      } else {
        // Fade out
        startAction.fadeOut(duration);
      }
      console.log("Action index from", this.current_action_index, "to", newChoice);
      this.current_action_index = newChoice;
      this.canChooseNew = true;
    },

    synchronizeCrossFade(startAction, endAction, duration, newChoice) {
      mixer.addEventListener('loop', onLoopFinished);
      let me = this;

      function onLoopFinished(event) {
        if (event.action._clip.name == startAction._clip.name) {
          mixer.removeEventListener('loop', onLoopFinished);
          me.executeCrossFade(startAction, endAction, duration, newChoice);
        }

      }
    },

    equation_plane(p1, p2, p3) {
      var x1 = p1.x;
      var x2 = p2.x;
      var x3 = p3.x;
      var y1 = p1.y;
      var y2 = p2.y;
      var y3 = p3.y;
      var z1 = p1.z;
      var z2 = p2.z;
      var z3 = p3.z;
      var a1 = x2 - x1;
      var b1 = y2 - y1;
      var c1 = z2 - z1;
      var a2 = x3 - x1;
      var b2 = y3 - y1;
      var c2 = z3 - z1;
      var a = b1 * c2 - b2 * c1;
      var b = a2 * c1 - a1 * c2;
      var c = a1 * b2 - b1 * a2;
      var d = (-a * x1 - b * y1 - c * z1);
      return new THREE.Vector4(a, b, c, d);
    },


    async init() {
      // global settings
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(25, window.innerWidth / window.innerHeight, 1, 1000);
      camera.position.set(0, 0, 50);
      camera.lookAt(scene.position);

      // scene.add( line );


      // define the renderer first
      renderer = new THREE.WebGLRenderer({ canvas: this.$refs.myCanvas, antialias: true, powerPreference: "high-performance", });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(window.innerWidth, window.innerHeight);
      renderer.setClearColor(bg_color, 1);
      // document.body.appendChild( renderer.domElement );


      controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
      controls.minDistance = 5;
      controls.maxDistance = 500;
      window.addEventListener('resize', this.onWindowResize);
      window.addEventListener('keyup', this.onKeyUp);

      let me = this;
      // Create a new loader instance
      loader = new FBXLoader();

      // Load the FBX file
      loader.load(
        'Cat_v01.fbx',
        (object) => {
          catObject = object;
          catObject.layers.toggle(1);

          me.bbox = new THREE.Box3().setFromObject(catObject);

          // set 50 planes
          for (var i = 0; i < shaderAttribute.lines; i++) {
            var p0 = new THREE.Vector3(0, 0, 0);
            var p1 = new THREE.Vector3(1, 0, 0);
            var p2 = new THREE.Vector3(0, 0, 1);

            // now rotate the points around x axis and z axis for a random degree
            var rotX = Math.random() * Math.PI;
            var rotZ = Math.random() * Math.PI;
            p1.applyAxisAngle(new THREE.Vector3(1, 0, 0), rotX);
            p2.applyAxisAngle(new THREE.Vector3(1, 0, 0), rotX);
            p1.applyAxisAngle(new THREE.Vector3(0, 0, 1), rotZ);
            p2.applyAxisAngle(new THREE.Vector3(0, 0, 1), rotZ);
            var transX = (Math.random() * (me.bbox.max.x - me.bbox.min.x) + me.bbox.min.x) / 2;
            var transZ = (Math.random() * (me.bbox.max.z - me.bbox.min.z) + me.bbox.min.z) / 2;
            var transY = (Math.random() * (me.bbox.max.y - me.bbox.min.y) + me.bbox.min.y) / 2;
            var translation = new THREE.Vector3(transX, transY, transZ);

            p0.add(translation);
            p1.add(translation);
            p2.add(translation);

            var plane_equation = me.equation_plane(p0, p1, p2);
            me.planes.push(plane_equation);
          }
          // set the planes uniforms
          myMaterial.uniforms.planes.value = me.planes;

          // set center
          var center = new THREE.Vector3();
          me.bbox.getCenter(center);
          myMaterial.uniforms.center.value = center;

          // set the min and max value
          myMaterial.uniforms.minOffset.value = me.bbox.min.z;
          myMaterial.uniforms.maxOffset.value = me.bbox.max.z;

          // set for each plane, an initial offset
          var offsets = [];
          for (var i = 0; i < shaderAttribute.lines; i++) {
            offsets.push(Math.random() * 2 * 3.1415926);
          }
          myMaterial.uniforms.offsets.value = offsets;

          // scale the cat
          catObject.scale.set(20, 20, 20);


          // set the cat material
          catObject.children[0].material = myMaterial;
          mixer = new THREE.AnimationMixer(catObject);
          for (var i = 0; i < me.action_numbers.length; i++) {
            const action = mixer.clipAction(catObject.animations[me.action_numbers[i]]);
            if (!action) {
              console.log("NO ACTION", i, me.action_numbers[i]);
            }
            me.animation_actions.push(action);
            if (i == 0) {
              me.animation_weights.push(1);
            } else {
              me.animation_weights.push(0);
            }
            me.activateAction(i);
          }


          scene.add(catObject);
          me.loadingDone = true;
          me.loading_text = "";
          clock = new THREE.Clock();
        },
        (xhr) => {
          me.loading_text = Math.max(0, Math.floor((xhr.loaded / xhr.total) * 100) - 1) + '% LOADED, IT MAY TAKE A WHILE';
          // console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
        },
        (error) => {
          console.log(error)
        }
      )
    },
    animate() {
      requestAnimationFrame(this.animate);
      controls.update();
      if (clock) {
        const delta = clock.getDelta();
        if (mixer) {
          mixer.update(delta);
          var elapsed = clock.getElapsedTime();
          if (elapsed - this.oldTime > 5 && this.canChooseNew && Math.random() > 0.9) {
            this.oldTime = elapsed;
            var newChoice = Math.floor(Math.random() * this.animation_actions.length);
            if (newChoice != this.current_action_index) {
              // console.log("new choice");
              this.canChooseNew = false;
              this.prepareCrossFade(this.animation_actions[this.current_action_index], this.animation_actions[newChoice], 0.35, newChoice);
            }
          }
          myMaterial.uniforms.time.value = elapsed;
        }
      }
      this.render();
    },

    render() {
      renderer.render(scene, camera);
    },

    onWindowResize() {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    },

    changeColor() {
      chosen_color = colors[Math.floor(Math.random() * colors.length)];
      // var choice1 = Math.random() > 0.5 ? 0 : 3;
      choice2 = Math.random() > 0.5 ? 0 : 1;
      bg_color = chosen_color[0];
      line_color1 = chosen_color[1 + choice2];
      line_color2 = chosen_color[2 - choice2];
      this.computedTextColor = chosen_color[3];
      renderer.setClearColor(bg_color, 1);
      myMaterial.uniforms.color1.value = new THREE.Color(line_color1);
      myMaterial.uniforms.color2.value = new THREE.Color(line_color2);
    },

    onKeyUp(e) {
      if (e.keyCode == 32) {
        this.changeColor();
      }
    }
  },

  async mounted() {
    await this.init();
    await this.animate();
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.canvWrapper {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0px;
  left: 0px;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 20px;
  z-index: 100;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
  font-weight: bold;
}

#loading_text {}

.createdBy {
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 10px;
  z-index: 100;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
  font-weight: bold;
}
</style>